<template>
    <div class="ticket-stack-widget">
        <div class="ticket-stack-widget__selection-list">
            <div
                v-for="event in mappedProps.events"
                :key="getUniqueKey(event)"
                class="ticket-stack-widget__selection-item"
            >
                <div
                    class="selection-row"
                    :class="{ 'selection-row--special': isSpecial }"
                >
                    <div class="selection-row__wrapper">
                        <EventSummary
                            :id="event.eventId"
                            :team1Name="event.teamNameOne"
                            :team2Name="event.teamNameTwo || ''"
                            :isLive="!!mappedProps.itemProps.liveEvents[event.eventId]"
                            :startDate="event.date"
                            :liveData="event.liveData"
                            :result="event.result"
                            :sportId="event.sportId"
                        />
                    </div>
                    <div class="selection-row__controls">
                        <i v-if="isSpecial(event)" class="icon icon-special" />
                        <div v-if="wasLive(event)">
                            <!-- eslint-disable  max-len-->
                            <span class="event-summary__match-indicator-live event-summary__match-indicator-live--before">
                                <!-- eslint-enable  max-len-->
                                <span class="event-summary__match-indicator-live-dot"></span>
                                <span class="event-summary__match-indicator-live-text">
                                    {{ $t('live bet') | capitalize }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div
                        class="selection-row__bet"
                        :class="statusClass(event.status)"
                    >
                        <div class="selection-row__market-box">
                            <span
                                v-if="event.eventNo"
                                class="selection-row__system-info"
                            >
                                {{ event.eventNo }}
                            </span>
                            <span
                                class="selection-row__market-name"
                                :title="event.market.name"
                            >
                                {{ event.market.name }}
                            </span>
                        </div>
                        <Pick
                            v-if="event.odd"
                            :id="parseInt(event.odd.oddId, 10)"
                            :eventId="event.eventId"
                            :value="event.odd.coefficient"
                            :symbol="event.odd.name"
                            :specialBetValue="event.odd.specialValue"
                            :isLocked="false"
                            :isRefund="isRefund(event)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <SystemRow
            v-if="system"
            v-bind="system"
            :minimumPotentialWin="minimumPotentialWin"
        />
        <TicketTableHeader :isWon="isWon"/>
        <TicketSummary
            class="summary"
            :hasOngoingEvents="hasOngoingEvents"
            v-bind="mappedProps.itemProps"
        />
    </div>
</template>

<script>
    import SystemRow from '@modules/shared/tickets/SystemRow';
    import EventSummary from '@modules/shared/event/EventSummary';
    import Pick from '@modules/shared/event/Pick.vue';
    import { EventStatus, TicketStatus, EventType } from '@core/models/tickets/enums';
    import { isSpecialEvent } from '@core/models/specials/SpecialEvent';
    import TicketSummary from '../TicketSummary';
    import TicketTableHeader from '../TicketTableHeader';


    export default {
        props: {
            events: {
                type: Array,
                required: true,
            },
            // child props
            id: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            system: {
                type: Object,
                default: null,
            },
            stake: {
                type: Number,
                required: true,
            },
            isWon: {
                type: Boolean,
                required: true
            },
            potentialWin: {
                type: Number,
                required: true,
            },
            minimumPotentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            coefficient: {
                type: Number,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                required: true
            },
            liveEvents: {
                type: Object,
                required: true,
            },
            hasOngoingEvents: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            isFinished() {
                return [
                    TicketStatus.refund,
                    TicketStatus.win,
                    TicketStatus.lost,
                    TicketStatus.payed,
                ].includes(this.status);
            },

            mappedProps() {
                const {
                    events,
                    ...props
                } = this.$props;
                return {
                    events,
                    itemProps: props,
                };
            },
        },
        methods: {
            statusClass(status) {
                switch (status) {
                    case EventStatus.win:
                        return 'selection-row__bet--won';
                    case EventStatus.lost:
                        return 'selection-row__bet--lost';
                    case EventStatus.refund:
                        return 'selection-row__bet--refund';
                    default:
                        return '';
                }
            },
            getUniqueKey(event) {
                return `${event.eventId}-${event.odd.oddId}`;
            },
            isSpecial(event) {
                return isSpecialEvent(event.eventId);
            },
            wasLive(event) {
                return event.type === EventType.live && event.status !== EventStatus.active;
            },
            isRefund(event) {
                return event.status === EventStatus.refund;
            },
        },
        components: {
            EventSummary,
            TicketSummary,
            TicketTableHeader,
            SystemRow,
            Pick,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/SportWidget/SportWidgetContent.vue